<template>
  <div id="technicians-filter">
    <TechniciansFilterOption
      v-for="(filter, idx) in filters"
      :key="idx"
      :item="filter"
      :change="updateFilter"
      :clear="clear"
      :loading="loading"
    />
  </div>
</template>

<script>
import TechniciansFilterOption from './technicianFilter/TechniciansFilterOption.vue';

export default {
  name: 'TechniciansFilters',
  components: {
    TechniciansFilterOption,
  },
  props: {
    loading: Boolean,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    change: Function,
    clear: Function,
  },
  watch: {
    filters(data) {
      this.filters = data;
    },
  },
  methods: {
    updateFilter(option, key) {
      const copyFilters = Object.freeze(this.filters);
      const newFilters = copyFilters.map((op) => {
        if (op.key === key) {
          op.active = true;
          op.activeOption = option;
        }
        return op;
      });
      this.change(newFilters);
    },
  },
};
</script>

<style lang="scss" scoped>

#technicians-filter {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  z-index: 2;
  font-size: 0.85em;
  .nav-button {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 44px;
    background-color: $N95;
    &.active {
      background-color: $NBLUE110;
      border-radius: 6px;
    }
    &:hover {
      background-color: $N90;
      border-radius: 6px;
    }
  }
}

</style>
